import { render, staticRenderFns } from "./RevertConfirmModal.vue?vue&type=template&id=0bf9e259&scoped=true"
import script from "./RevertConfirmModal.vue?vue&type=script&lang=js"
export * from "./RevertConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./RevertConfirmModal.vue?vue&type=style&index=0&id=0bf9e259&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9e259",
  null
  
)

export default component.exports